import type { Customer } from 'shopify-types'

import { isClubMember } from './club'

/** Resolved club membership for UI gating (dashboard vs. join vs. skeleton). */
export enum ClubMembershipStatus {
  Loading = 'loading',
  Member = 'member',
  NonMember = 'nonMember',
}

/** e2e escape hatch (NEXT_PUBLIC_, build-inlined); absent in prod/stage/dev. */
const MEMBERSHIP_GATE_DISABLED = process.env.NEXT_PUBLIC_DISABLE_CLUB_MEMBERSHIP_GATE === 'true'

/**
 * Membership from an authoritative customer (e.g. the server-fetched one).
 * Honors the gate-disable flag identically to the client hook, so the server
 * seed and the client value agree and never cause a hydration mismatch.
 */
export const resolveClubMembership = (
  customer: Pick<Customer, 'tags'> | null | undefined,
): ClubMembershipStatus => {
  if (MEMBERSHIP_GATE_DISABLED) return ClubMembershipStatus.Member
  return isClubMember(customer) ? ClubMembershipStatus.Member : ClubMembershipStatus.NonMember
}
